'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DataGridHeader", {
    enumerable: true,
    get: function() {
        return DataGridHeader;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useDataGridHeader = require("./useDataGridHeader");
const _renderDataGridHeader = require("./renderDataGridHeader");
const _useDataGridHeaderStylesstyles = require("./useDataGridHeaderStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const DataGridHeader = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useDataGridHeader.useDataGridHeader_unstable)(props, ref);
    (0, _useDataGridHeaderStylesstyles.useDataGridHeaderStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useDataGridHeaderStyles_unstable')(state);
    return (0, _renderDataGridHeader.renderDataGridHeader_unstable)(state);
});
DataGridHeader.displayName = 'DataGridHeader';
